<template>
  <!-- Main Content -->
  <div id="search-item-gallery" class="md-layout md-gutter w-100 justify-content-center" :key="feedKey">
    <div v-if="!allActivities.length && !isGroupPage">
      <div v-if="$attrs.userProfile.id === loggedUser.id" class="post-item-container">
        <h4 >You don't have any item posted yet.</h4>
        <SButtonMaterial class="post-item-button" buttonType="button" color="primary" textColor="white"
            materialClass="dense" text="post item" iconLeftText="add" iconColor="white" @button="openNewItemModal"
            data-cy="headerPostItem" />
      </div>
      <h4 v-else>{{$attrs.userProfile.firstName}} don't have any item posted yet</h4>
    </div>
    <div      
      v-for="(activity, index) in allActivities"
      :key="activity._id"
      class='md-layout-item'
    >
      <SNewItemMaterial
        :item="activity"
        v-if="
          activity.feedType === 'NEW_ITEM' &&
          isGroupPage
        "
        @openWindowPopup="openChat(activity)"
        @deleteItem="reloadData(index)"
      />
      <SNewMemberMaterial
        :member="activity"
        v-if="activity.feedType === 'NEW_MEMBER'"
        @openWindowPopup="openChat(activity)"
      />
    </div>
  </div>
  <!-- ... end Main Content -->
  <!-- Left Sidebar -->
</template>

<script>
import GroupHelperVue from "@/mixins/GroupHelper.vue";
import ChatHelperVue from "@/mixins/ChatHelper.vue";
import ItemHelperVue from "@/mixins/ItemHelper.vue";
import UserHelperVue from "@/mixins/UserHelper.vue";
import SNewMemberMaterial from "@/material-components/organisms/SNewMemberMaterial.vue";
import SNewItemMaterial from "@/material-components/organisms/SNewItemMaterial";
import item_status from "@/enum/item-status";
import SButtonMaterial from '../../material-components/atoms/SButtonMaterial.vue';

export default {
  name: "ActivityList",
  mixins: [GroupHelperVue, ChatHelperVue, ItemHelperVue, UserHelperVue],
  components: {
    SNewMemberMaterial,
    SNewItemMaterial,
    SButtonMaterial
},
  data() {
    return {
      selectedKeyChat: {},
      feedKey: 0,
      itemStatus: item_status,
    };
  },
  computed: {
    allActivities() {
      let sortedTimeline = [...this.getCurrentGroupTimeline];
      sortedTimeline.sort((a, b) => {
        const dateA = new Date(this.getLastItemTimeStamp(a)) || new Date();
        const dateB = new Date(this.getLastItemTimeStamp(b)) || new Date();
        return dateB - dateA;
      });

      return sortedTimeline.filter((activity) => activity.feedType === 'NEW_MEMBER' || (activity.feedType === 'NEW_ITEM' && this.isItemAvailable(activity)));
    },
    isGroupPage() {
      return this.$route.name === "GroupsTimeLine";
    },
  },
  methods: {
    openNewItemModal() {
      $("#new-item").modal("show");
    },
    openChat(key) {
      const selectedKeyId = key.group?.id ?? key.id;
      const msgs = this.userMessages.some((msg) => {
        return msg.key.id === selectedKeyId;
      });
      if (!msgs) {
        if (key.id && key.title) {
          key.feedType = "NEW_ITEM";
        }
        this.selectedKeyChat = {
          key: key,
          messages: [],
          firstTalk: true,
        };
      } else {
        this.selectedKeyChat = this.userMessages.find((msg) => {
          return msg.key.id === selectedKeyId;
        });
        this.selectedKeyChat.messages = this.selectedKeyChat.messages.filter(
          (msg) => {
            return (
              msg.senderId === key.user.id || msg.receiverId === key.user.id
            );
          }
        );
      }
      this.selectedKeyChat = {
        ...this.selectedKeyChat,
        partner: key.user,
      };
      this.setPopupChat({
        isOpen: true,
        chatMsgs: this.selectedKeyChat,
      });
      this.$parent.$parent.$refs.rightStickyBar.openClosePopup();
    },
    isItemAvailable(item) {
      return item.status === this.itemStatus.IDLE;
    },
    reloadData(index) {
      this.allActivities.splice(index, 1);
      this.feedKey += 1;
    },
    isMember(theGroup) {
      return !!(this.myGroups.some((group) => group.groupId === theGroup.id));
    },
  },
};
</script>

<style scoped>
.md-layout-item {
  margin: 0 8px 16px !important;
  padding: 0 !important;
  max-width: 576px;
}
.md-layout.md-gutter {
  margin: 0;
}
.cards-container {
  width: 100%;
}
  #newsfeed-items-grid {
    width: 100%;
    display: flex;
    gap:16px;
    flex-wrap: wrap;
    justify-content: space-evenly;

  }
  .post-item-container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .cards{
    width: 100%;
    min-width: none;
    max-width: 288px;
  }

</style>
